module.exports = __webpack_public_path__ + "img/Restore.eda9e4f8.svg";